
import React from 'react';
import { Route, Routes } from 'react-router-dom';

// Placeholder admin dashboard component
const AdminHome = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
      <p>Welcome to the admin dashboard. This is a placeholder page.</p>
    </div>
  );
};

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Admin header would go here */}
      <div className="flex">
        {/* Admin sidebar would go here */}
        <main className="flex-1">
          <Routes>
            <Route index element={<AdminHome />} />
            {/* More admin routes would go here */}
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
